import request from "../request";

/**
 * 支部成员情况
 * @param {*} data 
 */
export function getNumberapi(data) {
  return request.post('/admin/base/getNumber', data, { isauth: true })
}

/**
 * 会议类型统计
 * @param {*} data 
 */
export function getMeetingStatapi(data) {
  return request.post('/admin/base/getMeeting', data, { isauth: true })
}

/**
 * 党员风采
 * @param {*} data 
 */
export function getsStyleapi(data) {
  return request.post('/admin/organization/getsStyle', data, { isauth: true })
}



// export function home(data) {
//   return request.post('/api/user/get', data, { isauth: true })
// }
// export function searchapi(data) {
//   return request.post('/api/query/queryList', data, { isauth: true })
// }


// WEBPACK FOOTER //
// ./src/network/api/home.js